export enum EServiceTypeRate {
  RATE_BASED = "rate_based",
  FLAT_FEE = "flat_fee",
}

export enum EServiceTypeRateUnit {
  HOUR = "hour",
  PROJECT = "project",
  PIECE = "piece",
}

export const getServiceTypeRateUnitLabel = (rateUnit: EServiceTypeRateUnit) => {
  switch (rateUnit) {
    case EServiceTypeRateUnit.HOUR:
      return "Hour";
    case EServiceTypeRateUnit.PROJECT:
      return "Project";
    case EServiceTypeRateUnit.PIECE:
      return "Piece";
    default:
      return undefined;
  }
};

export const getServiceTypeRateLabel = (rate: EServiceTypeRate) => {
  switch (rate) {
    case EServiceTypeRate.RATE_BASED:
      return "Rate Based";
    case EServiceTypeRate.FLAT_FEE:
      return "Flat Fee";
    default:
      return undefined;
  }
};
